import type { ProductImage } from '../types/content';

export const productImages: Record<'white' | 'kit' | 'voice' | 'detail' | 'controller', ProductImage> = {
  white: {
    id: 'white',
    src: 'https://cdn.magicpatterns.com/uploads/6x5vo5a7CJk6kvXpcFAeox/White.jpg',
    alt: 'The AuraGlow Luxe facial light-therapy mask in white silicone, shown at an angle with its head strap',
    label: 'The mask in White',
    nativeWidth: 368,
  },
  kit: {
    id: 'kit',
    src: 'https://cdn.magicpatterns.com/uploads/pvKicNpwGk6SdNzCUKtNk8/White_Box.jpg',
    alt: 'The AuraGlow Luxe kit laid out: white mask, interior view of the mask, packaging, handheld controller, charging cable, manual and pouch',
    label: 'The full kit',
    nativeWidth: 368,
  },
  voice: {
    id: 'voice',
    src: 'https://cdn.magicpatterns.com/uploads/xxcx8xaVDeSQY13keEUnyj/Hi_Mask.png',
    alt: 'A person wearing the white mask at home, illustrating the "Hi Mask" voice command',
    label: '"Hi Mask" voice command',
    nativeWidth: 1000,
  },
  detail: {
    id: 'detail',
    src: 'https://cdn.magicpatterns.com/uploads/srwBPhy9DQXPkk2m7grHL5/Detail_Display.png',
    alt: 'Close-up details of the mask: side control housing, eye opening, interior light panel and the handheld controller',
    label: 'Close-up details',
    nativeWidth: 800,
  },
  controller: {
    id: 'controller-photo',
    src: 'https://cdn.magicpatterns.com/uploads/srwBPhy9DQXPkk2m7grHL5/Detail_Display.png',
    alt: 'Close-up of the included handheld controller with its display and control buttons',
    label: 'The handheld controller',
    nativeWidth: 403,
    crop: { x: 397, y: 1033, width: 403, height: 284, sourceWidth: 800, sourceHeight: 1372 },
  },
};

/**
 * Central site configuration.
 * Price and fulfillment copy were confirmed by the client on 14 October 2026.
 * `samplePrice` is the confirmed sale price displayed in this design prototype. The live price,
 * SKU, quantity rules, shipping and tax all come from the native product/checkout frames.
 */
export const siteConfig = {
  siteName: 'AuraGlowLuxe.com',
  brandName: 'AuraGlow Luxe',
  logoUrl: 'https://cdn.magicpatterns.com/uploads/rAa9xGneKVxWB4UXgBiRvR/Logo.jpg',
  product: {
    name: 'AuraGlow Luxe Mask',
    descriptor: 'Facial light-therapy mask',
    color: 'White',
    samplePrice: 394,
    regularPrice: 800,
    priceStatus: 'Client-confirmed on 14 October 2026; prototype display only',
    currency: 'USD',
  },
  fulfillment: {
    shippingLabel: 'Free shipping',
    dispatch: 'Usually ships in 1–2 days',
  },
  support: {
    phone: '1-800-753-7154',
    phoneHref: 'tel:+18007537154',
    timezone: 'Eastern',
    hours: [
      { days: 'Monday – Friday', time: '9am – 8pm' },
      { days: 'Saturday', time: '9am – 4pm' },
      { days: 'Sunday', time: '11am – 4pm' },
    ],
  },
} as const;

